import ru from "./ru.json";
import en from "./en.json";
import ua from "./ua.json";

export default {Locale: {ru, en, ua}};


// WEBPACK FOOTER //
// ./src/components/locale/index.js